export { GeorgeButton, IProps } from './GeorgeButton'
